var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Suche"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "sidebar-search",
                attrs: {
                  action: "?#",
                  method: "get",
                },
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "needles",
                  },
                  [
                    _c("li", [
                      _c(
                        "div",
                        {
                          staticClass: "input-group files-search",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "sr-only",
                              attrs: {
                                for: _vm.inputId,
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Suche nach …")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            attrs: {
                              type: "text",
                              id: _vm.inputId,
                              name: "search",
                              placeholder: _vm.$gettext("Suche nach …"),
                            },
                            domProps: {
                              value: _vm.search,
                            },
                          }),
                          _vm._v(" "),
                          _vm.search
                            ? _c(
                                "a",
                                {
                                  staticClass: "reset-search",
                                  attrs: {
                                    href: _vm.urlReset,
                                    tabindex: "0",
                                    role: "button",
                                    title: _vm.$gettext("Suche zurücksetzen"),
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "decline",
                                      size: 20,
                                      alt: "",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "submit-search",
                              attrs: {
                                type: "submit",
                                title: _vm.$gettext("Suche ausführen"),
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "search",
                                  size: 20,
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }